import {
  CaretLeftIcon,
  HomeIcon,
  IconButtonLink,
  IconButtonLinkIcon,
} from "@tandemdiabetes/sugarmate-react-components"
import { Link } from "@tanstack/react-router"
import type {
  ComponentProps,
  ReactNode,
} from "react"
import styles from "./PageHeader.module.scss"
import {
  NavigationMenuTrigger,
  UserInitialButton,
  UserName,
} from "src/components"
import { useFollowedUsers } from "src/contexts"
import type { RoutePath } from "src/types"

interface Props {
  user: ComponentProps<typeof UserInitialButton>["user"];
  backRoutePath?: RoutePath;
  backRouteParams?: ComponentProps<typeof Link>["params"];
  children?: ReactNode;
}

const defaultBackRouteParams = {}

export function PageHeader(props: Props) {
  const {
    user,
    children,
    backRoutePath,
    backRouteParams = defaultBackRouteParams,
  } = props

  const {
    currentFollow,
    currentUserId,
  } = useFollowedUsers()

  return (
    <div className={styles.container}>
      {backRoutePath ? (
        <IconButtonLink
          className={styles.backButton}
          stylePreset="withoutBackground"
          asChild
        >
          <Link
            to={backRoutePath}
            params={backRouteParams}
            search={{}}
            id="header-left-button"
          >
            <IconButtonLinkIcon>
              <CaretLeftIcon className={styles.backButtonIcon} />
            </IconButtonLinkIcon>
          </Link>
        </IconButtonLink>
      ) : (
        <IconButtonLink
          className={styles.homeButton}
          stylePreset="withoutBackground"
          asChild
        >
          <Link
            to={currentFollow.is_self ? "/home" : "/home/$accountId"}
            params={currentFollow.is_self ? {} : { accountId: currentUserId }}
            id="header-left-button"
          >
            <IconButtonLinkIcon>
              <HomeIcon className={styles.homeButtonIcon} />
            </IconButtonLinkIcon>
          </Link>
        </IconButtonLink>
      )}
      <div className={styles.centerText}>
        <div
          className={styles.title}
          id={"page-title"}
        >
          {children}
        </div>
        <div
          className={styles.userName}
          id="user-name-header"
        >
          <UserName user={user} />
        </div>
      </div>
      <NavigationMenuTrigger asChild>
        <UserInitialButton
          className={styles.menuButton}
          user={user}
        />
      </NavigationMenuTrigger>
    </div>
  )
}
